export default __webpack_public_path__ + "static/media/busi01.7616d99d.jpg";